"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { tbGotoClicked } from 'Actions/Table/TableToolBarActions';
import { System } from "Constants/objects";

var GotoButtonProps =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(GotoButtonProps, _BaseToolbarButtonPro);

  function GotoButtonProps(_ref) {
    var _this;

    var _formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        _ref$items = _ref.items,
        items = _ref$items === void 0 ? [] : _ref$items,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu", "title", "items"]);

    _classCallCheck(this, GotoButtonProps);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title,
      hint: title,
      disabled: true,
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.GOTO
      },
      items: items
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GotoButtonProps).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateUUID", function (formUUID) {
      _this._props.UUID = formUUID;
    });

    isContextMenu ? _this._props.UUID = _formUUID : _this._props.options.UUID = _formUUID;
    _this._items = items;
    if (isContextMenu) _this.setOptions({
      template: null
    });
    return _this;
  }

  _createClass(GotoButtonProps, [{
    key: "template",
    value: function template() {
      var menuData = [{
        items: this._items,
        template: function template() {
          return $("<span class=\"icon menu-dpdown no-icon\"><span class=\"dx-button-text\">Go to \u2026</span><i class=\"fas fa-caret-down\"></i></span>");
        }
      }];
      return $('<div class="custom-dropdown-menu">').dxMenu({
        dataSource: menuData,
        cssClass: "custom-dropdown-menu"
      });
    }
  }]);

  return GotoButtonProps;
}(BaseToolbarButtonProp);

_defineProperty(GotoButtonProps, "create", function (options) {
  return new GotoButtonProps(options).props();
});

export { GotoButtonProps as default };
;
export var GotoButtonItemProp =
/*#__PURE__*/
function () {
  function GotoButtonItemProp(_ref2) {
    var _this2 = this;

    var title = _ref2.title,
        ActionFormID = _ref2.ActionFormID,
        CustomParameters = _ref2.CustomParameters,
        _formUUID2 = _ref2.formUUID,
        rest = _objectWithoutProperties(_ref2, ["title", "ActionFormID", "CustomParameters", "formUUID"]);

    _classCallCheck(this, GotoButtonItemProp);

    _defineProperty(this, "onMouseDown", function (_ref3) {
      var url = _ref3.url,
          actionFormID = _ref3.actionFormID,
          customParameters = _ref3.customParameters,
          UUID = _ref3.UUID;
      tbGotoClicked({
        e: event,
        actionFormID: actionFormID,
        customParameters: customParameters,
        formUUID: UUID,
        url: url
      });
    });

    _defineProperty(this, "template", function (data, index, element) {
      var result = $("<div>").addClass('d5popover-with-list-li');

      if (!data.text) {
        return $("<span class=\"icon menu-dpdown\"><i class=\"dx-icon dx-icon-export\" style=\"font-size:20px;color:rgba(0, 0, 0, 0.54);\"/></span>");
      }

      if (data.icon) $("<div>").addClass("dx-icon dx-icon-".concat(data.icon)).appendTo(result);
      $("<div>").text(data.text).appendTo(result);
      element.hover(function () {
        $(this).css('background-color', '#f2f2f2');
      }, function () {
        $(this).css('background-color', '');
      });
      $(element).off('click').on('click', _this2.onMouseDown.bind(_this2, data));
      return result.appendTo(element);
    });

    _defineProperty(this, "updateUUID", function (formUUID) {
      _this2._props.UUID = formUUID;
    });

    this._props = _objectSpread({
      text: title,
      elementAttr: {
        'class': "table-form-goto-item"
      },
      template: this.template.bind(this),
      actionFormID: ActionFormID,
      customParameters: CustomParameters,
      UUID: _formUUID2,
      updateUUID: this.updateUUID
    }, rest);
  }

  _createClass(GotoButtonItemProp, [{
    key: "props",
    value: function props() {
      return _objectSpread({}, this._props);
    }
  }]);

  return GotoButtonItemProp;
}();

_defineProperty(GotoButtonItemProp, "create", function (options) {
  return new GotoButtonItemProp(options).props();
});